import { map } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IsUserLoggedInService } from 'src/app/services/user/is-user-logged-in.service';
import { ChatPage } from './../chat/chat.page';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { SubSink } from 'subsink';
import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { PublicApiService } from 'src/app/services/public/public-api.service';
import { CalendarOptions } from '@fullcalendar/angular';
import {
  PopoverController,
  AlertController,
  ToastController,
} from '@ionic/angular';
import { ApiService } from 'src/app/services/api/api.service';
import * as moment from 'moment';
import { BookingService } from 'src/app/services/booking/booking.service';
import SwiperCore, { Autoplay, Pagination, Navigation, Thumbs } from 'swiper';
import { BookingPopoverPage } from 'src/app/components/booking-popover/booking-popover.page';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
SwiperCore.use([Autoplay, Pagination, Navigation, Thumbs]);

@Component({
  selector: 'app-user',
  templateUrl: './user.page.html',
  styleUrls: ['./user.page.scss'],
})
export class UserPage implements OnInit {
  api_key: string = environment.google_calendar_api_key;
  req_body: any;
  @ViewChildren('loginRef') loginElements: QueryList<ElementRef>;
  auth2: any;

  moment: any = moment;
  subscription = new SubSink();
  userRes: any;
  bucket_url: string = environment.s3_bucket_url;
  profilePlaceholder: string = '/assets/images/profile-placeholder.png';
  coverPlaceholder: string = '/assets/images/cover-placeholder.jpg';
  user: any;
  calendarVisible = true;
  calendarOptions: CalendarOptions;
  video_url: string = '';
  paymentHandler: any = null;
  // columnSize: Number = 6.5;
  columnSize: Number = 8.5;
  isValid = false;
  user_music: boolean = false;
  first_music: any = [];
  userLoggedIn: boolean = false;
  isFavorite: boolean = false;
  userProfile: string = this.profilePlaceholder;
  isGalleryModalOpen: boolean = false;
  gallery_photos: any = [];
  thumbsSwiper: any;
  userEvents: any = [];
  dateEvents: any = [];
  isEventsModalOpen: boolean = false;
  isFollowing: boolean = false;
  totalFollowers: any = 0;

  showMap: boolean = true;
  showSpecials: boolean = false;
  showCalendarMobile: boolean = false;

  isBookNowModalOpen: boolean = false;

  upcomingBookings = null;
  isBookingsLoading: boolean = false;

  user_details = null;

  user_id: string = null;

  hasNoBookings: boolean = false;
  recordId: string = '';
  isPackageActive: boolean = false;

  display: any;
  center: google.maps.LatLngLiteral = {
    lat: environment.default_lat,
    lng: environment.default_long,
  };
  zoom = 8;
  markerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: 'https://cll-stage.s3.us-east-2.amazonaws.com/map-icons/travel.png',
  };
  markerPositions: google.maps.LatLngLiteral[] = [];
  isFollowModalOpen: boolean = false;
  followProfileForm: FormGroup;
  showSpinner: boolean = false;

  private httpClient2: HttpClient;       //For calling API without interceptor

  constructor(
    private bandService: PublicApiService,
    private route: ActivatedRoute,
    private router: Router,
    private modalCtrl: PopoverController,
    private apiService: ApiService,
    private bookingService: BookingService,
    private alertController: AlertController,
    private userLoggedService: IsUserLoggedInService,
    private fb: FormBuilder,
    private toast: ToastController,
    private http: HttpClient,
    handler: HttpBackend
  ) {
    if (localStorage.getItem('user_data')) {
      this.userLoggedIn = true;
    }
    this.userLoggedService._subscribeStatus.subscribe((value) => {
      this.isPackageActive = value;
    });

    this.httpClient2 = new HttpClient(handler);       //For calling API without interceptor
  }

  get name() {
    return this.followProfileForm.get('name');
  }
  get email() {
    return this.followProfileForm.get('email');
  }

  ngOnInit() {
    // this.getBandData();
    this.readyFollowForm();
  }

  readyFollowForm() {
    this.followProfileForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern('^[^@]+@([-\\w]+\\.)+[A-Za-z]{2,4}$'),
        ],
      ],
    });
  }

  onSubmit() {
    this.showSpinner = true;
    let profile_id = atob(this.route.snapshot.paramMap.get('userId')!);
    let data = {};
    let followData = {};
    data = {
      name: this.followProfileForm.value.name,
      user_id: this.followProfileForm.value.email,
      profile_id: profile_id,
      isFollowing: true,
    };
    followData = {
      name: this.followProfileForm.value.name,
      user_id: this.followProfileForm.value.email,
    };

    this.apiService.post('users/followUser', data).subscribe(
      (res) => {
        if (localStorage.getItem('FollowerData') === null) {
          localStorage.setItem('FollowerData', JSON.stringify(followData));
        }
        this.showSpinner = false;
        this.isFollowing = true;
        this.totalFollowers = this.totalFollowers + 1;
        let followings = [];
        if (localStorage.getItem('isFollowing') === null) {
          followings.push(profile_id);
        } else {
          followings = JSON.parse(localStorage.getItem('isFollowing'));
          followings.push(profile_id);
        }
        localStorage.setItem('isFollowing', JSON.stringify(followings));
        this.isFollowModalOpen = false;
      },
      (error) => {
        this.showSpinner = false;
        let response_message =
          'A problem occurred while following account, try again later.';
        this.presentErrorToast(response_message);
        // console.log(error);
      }
    );
  }

  async ionViewWillEnter() {
    let userProfileId;
    try {
      userProfileId = atob(this.route.snapshot.paramMap.get('userId')!);
      if (
        !this.userLoggedIn &&
        JSON.parse(localStorage.getItem('isFollowing')) &&
        JSON.parse(localStorage.getItem('isFollowing')).includes(userProfileId)
      ) {
        this.isFollowing = true;
      } else {
        this.isFollowing = false;
      }
      if (this.userLoggedIn) this.getBookings();
      this.invokeStripe();
      this.recordId = atob(this.route.snapshot.paramMap.get('userId')!);
      await this.getUserData(this.recordId);
      await this.getUserEvents(this.recordId);
    } catch (e) {
      // console.log("catch error ==> ",e);
      this.router.navigate(['404']);
    }
  }
  ionViewWillLeave() {
    this.subscription.unsubscribe();
  }

  ionViewDidEnter() {
    this.showCalendar();
  }

  showCalendar() {
    const angThis = this;
    this.calendarOptions = {
      height: '100%',
      headerToolbar: {
        left: 'prev',
        center: 'title',
        right: 'next',
      },
      initialView: 'dayGridMonth',
      initialDate: new Date(),
      eventDisplay: 'list-item',
      eventClick(arg) {
        angThis.getDateEvents(arg.event.startStr);
      },
    };
  }

  getDateEvents(date) {
    this.bandService
      .get(
        'events/eventsOfProfileByDate/' +
          atob(this.route.snapshot.paramMap.get('userId')!) +
          '/' +
          date
      )
      .subscribe((res: any[]) => {
        this.dateEvents = res['data'];
        this.isEventsModalOpen = true;
        this.googleAuthSDK();
        // console.log("user events on date ========>", date);
      });
  }

  async getUserData(recordId) {
    // let id = this.route.snapshot.paramMap.get('id');
    let url = '';
    let service: any;
    if (this.userLoggedIn) {
      url = 'profile/favorite/' + recordId;
      service = this.apiService;
      // console.log("api service");
    } else {
      service = this.bandService;
      url = 'profile/' + recordId;
      // console.log("band service");
    }
    this.subscription.sink = service.get(url).subscribe(
      (res: any[]) => {
        this.userRes = res['data'];
        console.log('user data resp ==>  ', this.userRes);
        this.userProfile = this.userRes?.user_account_information?.profile_image
          ? environment.s3_bucket_url +
            this.userRes?.user_account_information?.profile_image
          : this.profilePlaceholder;
        this.user = res['user'];
        this.isFavorite = res['favorite'] ? true : false;
        // this.columnSize =
        //   this.userRes?.account_type?.id == 3 ||
        //   this.userRes?.account_type?.id == 5
        //     ? 6.5
        //     : 8.5;
        this.video_url = this.userRes?.user_account_information
          ?.youtube_video_url
          ? this.bandService.getId(
              this.userRes?.user_account_information?.youtube_video_url
            )
          : 'error';
        this.user_music = this.userRes?.user_musics.length > 0 ? true : false;
        this.first_music =
          this.userRes?.user_musics?.length > 0
            ? this.userRes?.user_musics[0]
            : [];
        if (this.userLoggedIn)
          this.isFollowing = res['following'] ? true : false;
        this.totalFollowers = res['totalFollowers']
          ? Number(res['totalFollowers'])
          : 0;
        // this.user = res['user'];
        if (this.userRes?.user_contact_information) {
          this.markerPositions.push({
            lat: Number(this.userRes?.user_contact_information?.lat),
            lng: Number(this.userRes?.user_contact_information?.long),
          });
          this.display = {
            lat: Number(this.userRes?.user_contact_information?.lat),
            lng: Number(this.userRes?.user_contact_information?.long),
          };
          this.center = {
            lat: Number(this.userRes?.user_contact_information?.lat),
            lng: Number(this.userRes?.user_contact_information?.long),
          };
        }

        if (this.userRes?.account_type_id == 1) {
          this.markerOptions = {
            draggable: false,
            icon: '../../../assets/icons/bands-marker.png',
          };
        } else if (this.userRes?.account_type_id == 2) {
          this.markerOptions = {
            draggable: false,
            icon: '../../../assets/icons/comedians-marker.png',
          };
        } else if (this.userRes?.account_type_id == 3) {
          this.markerOptions = {
            draggable: false,
            icon: '../../../assets/icons/foodtruck-marker.png',
          };
        } else if (this.userRes?.account_type_id == 4) {
          this.markerOptions = {
            draggable: false,
            icon: '../../../assets/icons/user-marker.png',
          };
        } else if (this.userRes?.account_type_id == 5) {
          this.markerOptions = {
            draggable: false,
            icon: '../../../assets/icons/venues-marker.png',
          };
        } else if (this.userRes?.account_type_id == 6) {
          this.markerOptions = {
            draggable: false,
            icon: '../../../assets/icons/comedyclub-marker.png',
          };
        } else if (this.userRes?.account_type_id == 7) {
          this.markerOptions = {
            draggable: false,
            icon: '../../../assets/icons/artists-marker.png',
          };
        }
      },
      (error) => {
        // console.log("response error ==> ",error.status);
        if (error.status === 404) {
          this.router.navigate(['404']);
        }
      }
    );
  }

  getUserEvents(user_id) {
    this.userEvents = [];
    this.bandService
      .get('events/getProfileEvents/' + user_id)
      .subscribe((res: any[]) => {
        this.userEvents = res['data'];
        if (this.userEvents.length > 0) {
          this.calendarOptions.events = this.userEvents.map((evt) => {
            return {
              title: evt.event_title,
              date: evt.event_date,
              eventId: evt.id,
            };
          });
        }
      });
  }

  playTrack(container_class) {
    document
      .querySelectorAll('.' + container_class + ' .play')
      .forEach((elem) => elem.classList.add('hidden'));
    document
      .querySelectorAll('.' + container_class + ' .pause')
      .forEach((elem) => elem.classList.remove('hidden'));
    const video = document.getElementById(
      container_class
    ) as HTMLVideoElement | null;

    if (video != null) {
      video.play();
    }
  }

  pauseTrack(container_class) {
    document
      .querySelectorAll('.' + container_class + ' .play')
      .forEach((elem) => elem.classList.remove('hidden'));
    document
      .querySelectorAll('.' + container_class + ' .pause')
      .forEach((elem) => elem.classList.add('hidden'));
    const video = document.getElementById(
      container_class
    ) as HTMLVideoElement | null;

    if (video != null) {
      video.pause();
    }
  }

  goToUserArchiveVideos() {
    let userId = this.route.snapshot.paramMap.get('userId');
    this.router.navigate(['account-videos/' + userId]);
  }
  async openChatModal(event) {
    const modal = await this.modalCtrl.create({
      component: ChatPage,
      event,
      componentProps: {
        user_id: atob(this.route.snapshot.paramMap.get('userId'))!,
        profile_pic: this.userProfile,
      },
      cssClass: 'profile-chat-popover',
    });
    modal.present();
    await modal.onWillDismiss();
  }

  async viewUserGallery() {
    // const modal = await this.galleryModal.create({
    //   component: GalleryViewerPage,
    //   componentProps: { user_id: atob(this.route.snapshot.paramMap.get('userId'))! },
    //   cssClass: 'profile-gallery-modal'
    // });
    // modal.present();
    // await modal.onWillDismiss();
    this.isGalleryModalOpen = true;
    let user_id = atob(this.route.snapshot.paramMap.get('userId'))!;
    this.subscription.sink = this.bandService
      .get('users/getProfileGallery/' + user_id)
      .subscribe((res: any[]) => {
        this.gallery_photos = res;
      });
  }

  /*------------------------------------------
  --------------------------------------------
  makePayment() Function
  --------------------------------------------
  --------------------------------------------*/
  makePayment(amount: any) {
    let myThis = this;
    const paymentHandler = (<any>window).StripeCheckout.configure({
      key: environment.stripe_key,
      locale: 'auto',
      token: function (stripeToken: any) {
        let data = {
          amount: amount,
          token: stripeToken.id,
          last4: stripeToken.card.last4,
          email: stripeToken.email,
        };
        // console.log("makePayment", stripeToken);
        if (!myThis.userLoggedIn) {
          myThis.bandService.post('checkout', data).subscribe((res) => {
            let customer_id = res.payment.customer;
            let stripe = {
              customer_id: customer_id,
              receiver_id: myThis.recordId,
              amount: amount,
              transaction_id: res.payment.id,
              email: stripeToken.email,
            };

            myThis.bandService
              .put('checkout/update-user-stripe', stripe)
              .subscribe((res) => {
                // console.log("after updating user data", res);
              });
          });
        } else {
          myThis.apiService.post('checkout', data).subscribe((res) => {
            let customer_id = res.payment.customer;
            let stripe = {
              customer_id: customer_id,
              receiver_id: myThis.recordId,
              amount: amount,
              transaction_id: res.payment.id,
              email: stripeToken.email,
            };

            myThis.apiService
              .put('checkout/update-user-stripe', stripe)
              .subscribe((res) => {
                // console.log("after updating user data", res);
              });
          });
        }
      },
    });
    paymentHandler.open({
      name: 'Local & Live',
      description: 'Stripe Payment',
      amount: amount * 100,
    });
  }

  /*------------------------------------------
  --------------------------------------------
  invokeStripe() Function
  --------------------------------------------
  --------------------------------------------*/
  invokeStripe() {
    if (!window.document.getElementById('stripe-script')) {
      const script = window.document.createElement('script');

      script.id = 'stripe-script';
      script.type = 'text/javascript';
      script.src = 'https://checkout.stripe.com/checkout.js';
      script.onload = () => {
        this.paymentHandler = (<any>window).StripeCheckout.configure({
          key: environment.stripe_key,
          locale: 'auto',
          token: function (obj: any) {},
        });
      };

      window.document.body.appendChild(script);
    }
  }

  toggleMap() {
    this.showMap = !this.showMap;
  }

  toggleSpecials() {
    this.showSpecials = !this.showSpecials;
  }

  toggleCalendarMobile() {
    this.showCalendarMobile = !this.showCalendarMobile;
    this.showMobileCalendar();
  }

  showMobileCalendar() {
    const angThis = this;
    let events = this.calendarOptions.events;
    this.calendarOptions = {
      height: 'auto',
      headerToolbar: {
        left: 'prev',
        center: 'title',
        right: 'next',
      },
      events: events,
      contentHeight: 1400,
      initialView: 'dayGridMonth',
      initialDate: new Date(),
      eventDisplay: 'list-item',
      eventClick(arg) {
        angThis.getDateEvents(arg.event.startStr);
      },
    };
  }

  markFavorite(favorite) {
    this.isFavorite = !this.isFavorite;
    let user_id = atob(this.route.snapshot.paramMap.get('userId')!);
    let data = {
      is_favourite: favorite,
      profile_id: user_id,
      account_type_id: this.userRes?.account_type_id,
    };
    this.apiService.post('users/addFavourite', data).subscribe((res) => {
      // this.isFavorite = true;
    });
  }
  onWillDismiss(e) {
    this.isGalleryModalOpen = false;
    this.isEventsModalOpen = false;
    this.isFollowModalOpen = false;
    this.auth2 = null;
    document.getElementById("google-jssdk")?.remove();
  }

  closeModal() {
    this.isGalleryModalOpen = false;
    this.isEventsModalOpen = false;
    this.isFollowModalOpen = false;
    this.auth2 = null;
    document.getElementById("google-jssdk")?.remove();
  }

  followProfile() {
    let user_id = atob(this.route.snapshot.paramMap.get('userId')!);
    let data = {
      profile_id: user_id,
    };
    if (this.userLoggedIn) {
      this.apiService.post('users/followUser', data).subscribe(
        (res) => {
          this.isFollowing = true;
          this.totalFollowers = this.totalFollowers + 1;
        },
        (error) => {
          this.showSpinner = false;
          let response_message =
            'A problem occurred while following account, try again later.';
          this.presentErrorToast(response_message);
          // console.log(error);
        }
      );
    } else {
      this.isFollowModalOpen = true;
      this.followProfileForm.reset({
        name: '',
        email: '',
      });
    }
  }
  async unFollowProfile() {
    let alert = this.alertController.create({
      // header: 'Unfollow ',
      message: 'Do you want to Unfollow this profile?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            // console.log('Cancel clicked');
          },
        },
        {
          text: 'Unfollow',
          handler: () => {
            let user_id = atob(this.route.snapshot.paramMap.get('userId')!);
            let userFollowingId = localStorage.getItem('FollowerData')
              ? JSON.parse(localStorage.getItem('FollowerData')).user_id
              : '';
            let data = {
              profile_id: user_id,
              user_id: !this.userLoggedIn ? userFollowingId : '',
            };
            this.apiService.post('users/unFollowUser', data).subscribe(
              (res) => {
                this.isFollowing = false;
                this.showSpinner = false;
                this.totalFollowers = this.totalFollowers - 1;
                if (!this.userLoggedIn && localStorage.getItem('isFollowing')) {
                  let newIds = [];
                  let followingsIds = JSON.parse(
                    localStorage.getItem('isFollowing')
                  );
                  followingsIds.map((id) => {
                    if (id !== user_id) newIds.push(id);
                  });
                  localStorage.removeItem('isFollowing');
                  localStorage.setItem('isFollowing', JSON.stringify(newIds));
                }
              },
              (error) => {
                this.showSpinner = false;
                let response_message =
                  'A problem occurred while Un-following account, try again later.';
                this.presentErrorToast(response_message);
                // console.log(error);
              }
            );
          },
        },
      ],
    });
    (await alert).present();
  }

  async presentSuccessToast(res_message) {
    const toast = await this.toast.create({
      header: 'Success',
      color: 'success',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  async presentErrorToast(res_message) {
    const toast = await this.toast.create({
      header: 'Failed',
      color: 'danger',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  async showBookNowPopover() {
    this.getBookings();
    this.user_details = {
      first_name: this.userRes.first_name,
      last_name: this.userRes.last_name,
      profile_image: this.userRes.user_account_information?.profile_image,
    };
    this.isBookNowModalOpen = true;
  }

  closeBookNowModal() {
    this.isBookNowModalOpen = false;
  }

  getBookings() {
    this.user_id = atob(this.route.snapshot.paramMap.get('userId')!);
    let data = {
      profile_id: this.user_id,
    };
    this.subscription.sink = this.bookingService
      .getUserUpcomingBookings(data)
      .subscribe(
        (res: any) => {
          this.upcomingBookings = res.data;
        },
        (error) => {
          if (error.status === 404) {
            this.hasNoBookings = true;
          }
          console.log(error);
        }
      );
  }

  // async presentConfirm(booking_id) {
  //   let alert = this.alertCtrl.create({
  //     // header: 'Confirm purchase',
  //     message: 'Do you want to confirm this booking?',
  //     buttons: [
  //       {
  //         text: 'Cancel',
  //         role: 'cancel',
  //         handler: () => {
  //           // console.log('Cancel clicked');
  //         }
  //       },
  //       {
  //         text: 'Confirm',
  //         handler: () => {
  //           this.isBookingsLoading = true;
  //           // console.log('Booking confirmed');
  //           this.bookNow(booking_id);
  //         }
  //       }
  //     ]
  //   });
  //   (await alert).present();
  // }

  async showBookingPopover(booking) {
    let booking_id = booking.id;
    const pop = await this.modalCtrl.create({
      component: BookingPopoverPage,
      componentProps: { booking_id: booking_id },
      cssClass: 'booking-popover',
    });
    pop.present();
    const { data } = await pop.onDidDismiss();
    if (data !== undefined) {
      this.getBookings();
    }
  }

  upcomingEvents() {
    let user_id = atob(this.route.snapshot.paramMap.get('userId')!);

    this.bandService
      .get('events/upcomingProfileEvents/' + user_id)
      .subscribe((res: any[]) => {
        this.userEvents = res['data'];
        this.dateEvents = res['data'];
        this.isEventsModalOpen = true;
        if (this.userEvents.length > 0) {
          this.calendarOptions.events = this.userEvents.map((evt) => {
            return {
              title: evt.event_title,
              date: evt.event_date,
              eventId: evt.id,
            };
          });
        }
      });
  }

  googleAuthSDK() {
    console.log('google auth sdk called');
    (<any>window)['googleSDKLoaded'] = () => {
      (<any>window)['gapi'].load('auth2', () => {
        this.auth2 = (<any>window)['gapi'].auth2.init({
          client_id:
            '138701212350-asq6m4uk031kbcie8pudep6h80etj303.apps.googleusercontent.com',
          plugin_name: 'login',
          cookiepolicy: 'single_host_origin',
          scope: 'https://www.googleapis.com/auth/calendar',
        });
        this.callLogin();
      });
    };

    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement('script');
      js.id = id;
      js.src = 'https://apis.google.com/js/platform.js?onload=googleSDKLoaded';
      fjs?.parentNode?.insertBefore(js, fjs);
    })(document, 'script', 'google-jssdk');
  }

  callLogin() {
    this.loginElements.forEach((element)=>{
      this.auth2.attachClickHandler(element.nativeElement,{},(googleAuthUser: any) => {
        //Print profile details in the console logs
        let profile = googleAuthUser.getBasicProfile();
        let email = profile.getEmail();
        let access_token = googleAuthUser.getAuthResponse().access_token;
        this.insertGoogleCalendarEvent(email, access_token);
      }, (error: any) => {
        // console.log("login error => ", error);
        let response_message = "Google login failed. Event was not added to Google Calendar.";
        this.presentErrorToast(response_message);
      });
    })
  }

  syncEvent(eventInfo) {
    // console.log('event ===> ', eventInfo);
    if (eventInfo.all_day_event) {
      this.req_body = {
        start: {
          date: eventInfo.event_date,
        },
        end: {
          date: eventInfo.event_end_date,
        },
        summary: eventInfo.event_title,
        description: eventInfo.event_description,
        location: eventInfo.event_address,
      };
    } else {
      this.req_body = {
        start: {
          dateTime:
            eventInfo.event_date + 'T' + eventInfo.event_start_time + '+05:00',
        },
        end: {
          dateTime:
            eventInfo.event_end_date +
            'T' +
            eventInfo.event_end_time +
            '+05:00',
        },
        summary: eventInfo.event_title,
        description: eventInfo.event_description,
        location: eventInfo.event_address,
      };
    }
    // console.log('event req body ===> ', this.req_body);
  }

  insertGoogleCalendarEvent(email, access_token) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${access_token}`,
    };
    this.subscription.sink = this.httpClient2
      .post(
        `https://content.googleapis.com/calendar/v3/calendars/${email}/events?alt=json&key=${this.api_key}`,
        this.req_body,
        {
          headers: new HttpHeaders(headers),
        }
      )
      .subscribe(
        (res: any) => {
          // console.log('insert resp ==> ', res);
          let response_message = "Event added to Google Calendar successfully";
          this.presentSuccessToast(response_message);
        },
        (error) => {
          // console.log('insert error ==> ', error);
          let response_message = "A problem occurred while adding event to your Google Calendar, try again later."
          this.presentErrorToast(response_message);
        }
      );
  }
}
